import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";
// tslint:disable
export const yammer_praise_diamond: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-diamond" {...rest}>
      <title>praise-diamond</title>
      <ellipse
        transform="rotate(-88.267 74.997 75.003) scale(.99996)"
        fill="#F8AE41"
        cx="75"
        cy="75"
        rx="75"
        ry="75"
      ></ellipse>
      <path fill="#FFF" d="M129.1 64.3H21.3l21.8-25.1H104z"></path>
      <path fill="#6C98D9" d="M73.8 122.5L21.3 64.3h107.9z"></path>
      <path fill="#9AC3FF" d="M43.1 39h30.5L56.5 64.4zm30.5 0h30.5L92.9 64.8z"></path>
      <path fill="#9AC3FF" d="M56.5 64h36.7l-19.4 58.5z"></path>
    </svg>
  );
};
